<template>
    <div>
      <h1>Setting</h1>
    </div>
  </template>
  
  <script setup>
  </script>